import styled from 'styled-components'
import { LoadingOverlay } from '@velasca/ui/loading-overlay'

export const CartPageContainer = styled(LoadingOverlay)`
  display: flex;
  max-width: 1600px;
  margin: 0 auto;
  font-family: ${({ theme }) => theme.fonts.brand};
  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`
